export enum SubscriptionChannel {
    UNKNOWN = 0,
    DIRECT = 1,
    PAX8 = 2
}
